<template>
	<div id="contact" class="mb-5">
		<div class="container">
			<hr class="hr-black">
			<div class="row py-5">
				<div class="col-12">
					<h2 class="text-center">
						Skontaktuj się
					</h2>
				</div>
			</div>
			<div class="row pb-5">
				<div class="col-12 col-lg-8 offset-lg-2">
					<Form />
				</div>
			</div>
			<hr class="hr-black">
			<div class="row mt-4 ">
				<div class="col-12 col-lg-8 offset-lg-2">
					<div class="row">
						<div class="col-12 col-lg-4 contact-data" id="email-elem">
							<p class="mb-0 fw-500">
								E-mail
							</p>							
							<span v-html="fillEmail()" @click="emailTracking"></span>					
						</div>
						<div class="col-12 col-lg-4 contact-data">
							<p class="mb-0 fw-500">
								Stacjonarny
							</p>
							<a href="tel:228121949" class="h5 fw-500 contact--alt" @click="phoneTracking('228-121-949')">228-121-949</a>							
						</div>
						<div class="col-12 col-lg-4 contact-data">
							<p class="mb-0 fw-500">
								Komórka
							</p>
							<a href="tel:530330300" class="h5 fw-500 contact--alt" @click="phoneTracking('530-330-300')">530-330-300</a>							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Form from '@/components/Form.vue';
	export default{
		components: {
			Form
		},
		methods: {
			fillEmail (){
				let part1 = "biuro",
					part2 = Math.pow(2,6),
					part3 = String.fromCharCode(part2),
					part4 = "ango.waw.pl",
					part5 = part1 + String.fromCharCode(part2) + part4;

				return '<a href="' + 'mai' + 'lto' + ':' + part5 + '" class="h5 fw-500 contact--alt">' + part1 + part3 + part4 + '</a>';
			},
			phoneTracking(number) {
				this.$gtag.event('Wybranie numeru', {
					'event_category': 'Zadzwoń do nas',
					'event_label': number,
					'non_interaction': false
				})
			},
			emailTracking() {
				this.$gtag.event('Kliknięcie w email', {
					'event_category': 'E-mail',
					'event_label': 'biuro@ango.waw.pl',
					'non_interaction': false
				})
			}
		}
	}
</script>